import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'
import { isObject } from 'lodash';

const state: DocumentState = {
}

const getters: GetterTree<DocumentState, RootState> = {

}

const actions: ActionTree<DocumentState, RootState> = {
  fetch(context, payload) {
    let slug = payload,
      config = ''
    if (isObject(payload)) {
      slug = payload['slug'] ?? ''
      config = payload['config'] ?? null
    }
    return http.v1.doc.fetch(slug, config)
  },
}

const mutations: MutationTree<DocumentState> = {

}

const doucment: Module<DocumentState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default doucment